import { UxFooter, UxFooterItem, UxText } from '@libui/ux-default-lib'
<template>
  <div class="footer">
    <ux-footer slot="bottom">
      <ux-footer-item class="brand">© 2025 - SURAVENIR </ux-footer-item>
      <ux-footer-item class="item"
        ><a
          href="https://www.suravenir.fr/mentions-legales/"
          target="_blank"
          class="color-p-state"
          aria-label="Accéder à la page Mentions Légales"
          >MENTIONS LEGALES</a
        ></ux-footer-item
      >
      <ux-footer-item class="item"
        ><a
          href="https://www.suravenir.fr/informations-reglementaires/"
          target="_blank"
          class="color-p-state"
          aria-label="Accéder à la page Informations Réglementaires"
          >INFORMATIONS REGLEMENTAIRES</a
        ></ux-footer-item
      >
    </ux-footer>
  </div>
</template>

<style scoped>
.footer {
  background-color: #333;
  color: white;
  height: 65px;
  line-height: 0px;
}

.brand {
  padding-left: 20px;
}
.item {
  padding-left: 10%;
}
</style>
